import { DeleteOutlined, SettingOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { PropsWithChildren, useCallback, useState } from "react";

export interface EdgeContextMenuProps {
    onSettings?: () => void;
    onDelete?: () => void;
    disabled?: boolean;
}

export const EdgeContextMenu = ({
    children,
    onSettings,
    onDelete,
    disabled = false,
}: PropsWithChildren<EdgeContextMenuProps>) => {
    const { t } = usePaldockTranslation("components.connection-creator");
    const [open, setOpen] = useState(false);

    const handleMenuClick: MenuProps["onClick"] = useCallback(
        ({ key }: { key: string }) => {
            setOpen(false);
            switch (key) {
                case "settings":
                    onSettings?.();
                    break;
                case "delete":
                    onDelete?.();
                    break;
            }
        },
        [onSettings, onDelete]
    );

    const menuItems: MenuProps["items"] = [
        {
            key: "settings",
            icon: <SettingOutlined />,
            label: t("context_menu.settings"),
        },
        {
            type: "divider",
        },
        {
            key: "delete",
            icon: <DeleteOutlined />,
            label: t("context_menu.delete"),
            danger: true,
        },
    ];

    if (disabled) {
        return <>{children}</>;
    }

    return (
        <Dropdown
            menu={{ items: menuItems, onClick: handleMenuClick }}
            trigger={["contextMenu"]}
            open={open}
            onOpenChange={setOpen}
        >
            <span className="inline-block">{children}</span>
        </Dropdown>
    );
};
